import { AxiosResponse } from 'axios'
import axios from '@/services/axios'

export default abstract class ReportApi {
  public static route = process.env.VUE_APP_SHOP_V2_BASE_URI

  public static async report(
    arenaId: string,
    dateGte: string,
    dateLt: string,
  ): Promise<AxiosResponse> {
    const url = `${this.route}/report`
    return await axios.get(url, {
      params: {
        arena_ids: arenaId,
        step: 'day',
        date_gte: dateGte,
        date_lt: dateLt,
      },
    })
  }

  public static async variantsReport(
    arenaId: number | string,
    exportFormat: 'pdf' | 'csv',
    dateGte: string,
    dateLt: string,
    dayType: 'business' | 'calendar' = 'business',
  ): Promise<AxiosResponse> {
    const acceptHeader = exportFormat === 'pdf' ? 'application/pdf' : 'text/csv'
    return await axios.get(`${this.route}/arenas/${arenaId}/variants-report`, {
      responseType: 'blob',
      headers: {
        Accept: acceptHeader,
      },
      params: {
        date_gte: dateGte,
        date_lt: dateLt,
        day_type: dayType,
      },
    })
  }
}
